// Holds a box clear of the viewport edge: one ending flush against it reads as cut off even when all of it is on screen.
const EDGE_GAP = 24;
// Roughly four option rows: below this a list is too cramped to scan, so the other side wins if it has more room.
const MIN_USABLE_HEIGHT = 160;

export type VerticalSide = 'below' | 'above';

type VerticalExtent = Readonly<{ top: number; bottom: number }>;

/**
 * Height a box can take below and above `anchor` inside `boundary`.
 * `offset` is the box's own distance from the anchor (its margin or popover padding).
 */
export function verticalBudgets(
  anchor: VerticalExtent,
  boundary: VerticalExtent,
  offset: number
): Record<VerticalSide, number> {
  const margins = offset + EDGE_GAP;
  return {
    below: boundary.bottom - anchor.bottom - margins,
    above: anchor.top - boundary.top - margins,
  };
}

/** Below when it has a usable height, otherwise the roomier side. */
export function preferredSide(
  budgets: Record<VerticalSide, number>
): VerticalSide {
  if (budgets.below >= MIN_USABLE_HEIGHT) return 'below';
  return budgets.above > budgets.below ? 'above' : 'below';
}
